import React from "react";
import { StyleSheet } from "react-native";
import ScreenLayout from "./base/ScreenLayout";
import Title from "./base/Title";
import Text from "./base/Text";
import ScrollView from "./base/ScrollView";
import { layout } from "@/constants";

interface AgreementPageProps {
  /** The title of the agreement page */
  title: string;
  /** The content text to display */
  content: string;
}

/**
 * A reusable component for displaying agreement pages (terms, privacy, etc.).
 */
export default function AgreementPage({ title, content }: AgreementPageProps) {
  return (
    <ScreenLayout>
      <ScrollView contentContainerStyle={styles.container}>
        <Title>{title}</Title>
        <Text size="small" color="secondary">
          {content}
        </Text>
      </ScrollView>
    </ScreenLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: layout.space.lg,
    paddingVertical: layout.space.xl
  }
});
